import { render, staticRenderFns } from "./payadvanceShipmentMoney.vue?vue&type=template&id=0b871146&scoped=true"
import script from "./payadvanceShipmentMoney.vue?vue&type=script&lang=js"
export * from "./payadvanceShipmentMoney.vue?vue&type=script&lang=js"
import style0 from "./payadvanceShipmentMoney.vue?vue&type=style&index=0&id=0b871146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b871146",
  null
  
)

export default component.exports